const Tehsil = {

    // FIELDS
    "name": "Name",
    "district": "District",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "tehsil": "Tehsil",

    // ERROR
    "error_district": "Select District",
    "error_status": "Select Status",
    "error_name": "Enter Name",

    // TABLE HEADER
    "table_name": "NAME",
    "table_district": 'DISTRICT',
    "table_status": 'STATUS',

}

export default Tehsil;